;(function (GC) {
  var GCKissmetrics = function (analytics) {
    var analytics = analytics || {}
    var kissmetrics = {
      event: function (event) {
        var km = window._kmq || []
        km.push(event)
      },
    }

    return {
      kissmetrics: kissmetrics,
    }
  }

  GC.queue = GC.queue || []

  GC.queue.push({
    method: function (mount, GCmodule) {
      this._loadModule(mount, GCmodule)
    },
    args: ['analytics', new GCKissmetrics()],
  })

  window.GC = GC
})(window.GC || {})
